import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

import { BubbleButton } from '../../containers/hrAssistant/BubbleButton';
import HrAssistantContainer from '../../containers/hrAssistant/HrAssistantContainer';

import { EMPLOYEE } from '../../containers/hrAssistant/utils/constants';

export const InternalChatBot = () => {
  const chatIframeRef = useRef(null);

  useEffect(() => {
    const handleMessage = e => {
      if (!chatIframeRef.current) return;
      if (e.data === 'openChat') {
        chatIframeRef.current.style.display = 'block';
      } else if (e.data === 'closeChat') {
        chatIframeRef.current.style.display = 'none';
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <>
      <ButtonWrapper>
        <BubbleButton />
      </ButtonWrapper>
      <HrAssistantWrapper id="chat-iframe" ref={chatIframeRef}>
        <HrAssistantContainer embed={true} assistantType={EMPLOYEE} />
      </HrAssistantWrapper>
    </>
  );
};

const ButtonWrapper = styled.div`
  position: fixed !important;
  height: 60px;
  width: 60px;
  bottom: 20px;
  right: 20px;
  z-index: 2147483647;
  border: none;
`;

const HrAssistantWrapper = styled.div`
  position: fixed !important;
  height: 600px;
  width: 400px;
  bottom: 85px;
  right: 25px;
  z-index: 2147483647;
  display: none;
  border: none;
`;
